

<div class="mat-paginator-container">
  <div class="mat-paginator-container mat-paginator">
    <div class="paginator-page-size ng-star-inserted">
      <div class="mat-paginator-page-size-label "> Items per page: </div>

      <mat-form-field
        class="mat-paginator-page-size-select">
        <mat-select
          [value]="pageSize"
          (selectionChange)="changePageSize($event.value)">
          <mat-option *ngFor="let pageSizeOption of pageSizeOptions" [value]="pageSizeOption">
            {{pageSizeOption}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="mat-paginator-range-actions">
        <div class="mat-paginator-range-label">
          page: {{pageIndex}}
        </div>


        <button mat-icon-button (click)="moveFirstPage()" [disabled]="isFirstPage()">
          <mat-icon>first_page</mat-icon>
        </button>


        <button mat-icon-button (click)="movePreviousPage()" [disabled]="isFirstPage()">
          <mat-icon>navigate_before</mat-icon>
        </button>

        <button mat-icon-button (click)="moveNextPage()" [disabled]="isLastPage()">
          <mat-icon>navigate_next</mat-icon>
        </button>






      </div>

      </div>
    </div>
</div>












<!--
<div class="paginator-container">
  <div class="paginator-container-item-label">
    <h4>items per page:</h4>
  </div>
  <div class="paginator-container-item-select">
    <mat-form-field class="select-page">
      <mat-select [(value)]="selected" (selectionChange)="numOfPageChanged()">
        <mat-option [value]=25>25</mat-option>
        <mat-option [value]=50>50</mat-option>
        <mat-option [value]=100>100</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="paginator-container-item-nav-buttons">

    <button mat-icon-button (click)="moveFirstPage()">
      <mat-icon>first_page</mat-icon>
    </button>


    <button mat-icon-button (click)="movePreviousPage()">
      <mat-icon>navigate_before</mat-icon>
    </button>

    <button mat-icon-button (click)="moveNextPage()">
      <mat-icon>navigate_next</mat-icon>
    </button>

  </div>

</div>
-->
